import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromPadlockToken from "./padlock-token.reducer";

export const selectPadlockTokenState =
  createFeatureSelector<fromPadlockToken.PadlockTokenState>(
    fromPadlockToken.padlockTokenFeatureKey,
  );

export const selectCredentialLoginPending = createSelector(
  selectPadlockTokenState,
  (state) => Boolean(state?.pending),
);

export const selectCredentialLoginError = createSelector(
  selectPadlockTokenState,
  (state) => Boolean(state?.credentialError),
);
